import React, { Fragment, useState, useEffect } from 'react';
import { Button, UncontrolledTooltip, Row, Col } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import MomentUtils from '@date-io/moment';
import "moment/locale/es";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from "moment";
import 'moment-timezone';
import AlertModal from '../../../shared/components/Modal';

const UserDocumentsModalForm = ({ fileInformation, opened, close, idUser, Callback }) => {

    const [nameDocument, setNameDocument] = useState(null);
    const [dateEndFile, setDateEndFile] = useState(null);
    const [statusDocument, setStatusDocument] = useState(false);
    const [fileUser, setFileUser] = useState(null);
    const [alertModalSuccess, setAlertModalSuccess] = useState(false);
    const [alertModalError, setAlertModalError] = useState(false);

    const defaultMaterialTheme = createMuiTheme({
        palette: {
            primary: {
                main: '#3EA3FC',
                contrastText: "#fff"
            },
        },
    });

    useEffect(() => {

    }, []);


    const uploadDocuments = async () => {
        let dataFile = new FormData();
        dataFile.append("id_usuario", idUser);
        dataFile.append("vencido", statusDocument);
        dataFile.append("fecha_carga", moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss"));
        dataFile.append("fecha_vencimiento", moment(dateEndFile).format("YYYY-MM-DD HH:mm:ss"));
        dataFile.append("tipo", 1);
        dataFile.append("nombre_archivo", nameDocument);
        dataFile.append("documento", fileUser);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'docs-usuario/create', {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFile
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setAlertModalSuccess(true);
            }
            else {
                throw new Error("Ha ocurrido un error en el servidor");
            }
        }).catch(err => {
            setAlertModalSuccess(false);
            console.log(err);
        })
    }


    return (<Fragment>
        <Modal
            open={opened}
            onClose={e => {
                close();
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <div>
                    <div className="card__title">
                        {fileInformation == null ? <h5 className="bold-text">Subir Archivo</h5>
                            : <h5 className="bold-text">Actualizar Archivo</h5>
                        }
                    </div>
                </div>

                <div>
                    <Row>
                        <Col md={4}>
                            <TextField
                                required
                                className="medical-material-form__field"
                                id="name-document"
                                label="Nombre del Documento"
                                type="text"
                                value={nameDocument}
                                onChange={(e) => {
                                    setNameDocument(e.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                        </Col>
                        <Col md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <ThemeProvider theme={defaultMaterialTheme}>
                                    <DatePicker
                                        variant="inline"
                                        label="Fecha de Vencimiento"
                                        value={dateEndFile}
                                        onChange={(date) => {
                                            setDateEndFile(date);
                                        }}
                                        format="yyyy/MM/DD"
                                        animateYearScrolling
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }, shrink: true
                                        }}
                                        style={{ width: 300 }}
                                        autoOk={true}
                                    />
                                </ThemeProvider>
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={4}>
                            <TextField
                                required
                                className="medical-material-form__field"
                                id="name-document"
                                label="Estado del Documento"
                                type="text"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                                value={statusDocument}
                                onChange={(e) => {
                                    setStatusDocument(e.target.value);
                                }}
                                select
                            >
                                <MenuItem key={0} value={false}>
                                    Activo
                                </MenuItem>
                                <MenuItem key={1} value={true}>
                                    Vencido
                                </MenuItem>
                            </TextField>
                        </Col>
                    </Row>
                    <br /> <br />

                    <input
                        id="txtFile"
                        style={{ width: '80%' }}
                        type="file"
                        onChange={(e) => {
                            setFileUser(e.target.files[0]);
                        }}
                    />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {fileInformation == null ? <Button
                        disabled={false}
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => {
                            uploadDocuments();
                        }}
                    >
                        Subir Archivo
                    </Button> : <Button
                        disabled={false}
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => {
                            console.log("Actualizando");
                        }}
                    >
                        Actualizar Archivo
                    </Button>}
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                            close();
                        }}
                    >
                        Cerrar
                    </Button>
                </div>
            </div>
        </Modal>

        <AlertModal
            color="danger"
            title="Ha ocurrido un error subiendo el Archivo"
            modal={alertModalError}
            onOk={() => setAlertModalError(false)}
            toggle={() => setAlertModalError(false)}
        />

        <AlertModal
            color="success"
            title="Documento subido al sistema exitosamente"
            modal={alertModalSuccess}
            onOk={() => {
                setAlertModalSuccess(false);
                close();
                Callback();
            }}
            toggle={() => setAlertModalSuccess(false)}
        />

    </Fragment>)
}

export default UserDocumentsModalForm;